import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import _ from 'lodash';

const initialState = {
    MLEXLOG: {},
    MLAQUATICS: {},
    MLEVAL: {},
    MLFCEPOET: {},
    MLGAIT: {},
    MLMANUAL: {},
    MLMODALITIES: {},
    MLNEURO: {},
    MLOTHER: {},
    MLPHYSRECOND: {},
    MLSELFCARE: {},
    MLSPECIALTYTESTS: {},
    MLSPEECH: {},
    MLWORKPROG: {},
    MLTHERACT: {},
    MLTHEREX: {},
    MLWORKHARD: {},
};

export const reducer = createReducer(initialState, {
    [patientActions.loadAlSuccess]: (state, action) => {
        return _.merge(state, action.payload.data.entities);
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.alContainer.entities) {
            return { ...state, ...action.payload.alContainer.entities };
        } else {
            return state;
        }
    },
    [patientActions.closeSuccess]: (state, action) => {
        Object.keys(state)
            .forEach(key => {
                Object.keys(state[key])
                    .filter(key2 => state[key][key2].PTNO === action.payload)
                    .forEach(key2 => delete state[key][key2]);
            });
    },
})
